import React from 'react';
import { IconKpiRow } from '../../shared_components';
import { buildTrackerKpiCards } from '../utils';

const KpiCards = ({ kpis, onSelectTab }) => <IconKpiRow cards={buildTrackerKpiCards(kpis)} onSelect={onSelectTab} />;

export default KpiCards;
